/**
 * DropsToolbar
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';
import { Filter, Search } from 'lucide-react';

import { Button } from '@/components/ui';
import { Input } from '@/components/ui';

interface DropsToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;

  fetchLengthDraft: number;
  onFetchLengthDraftChange: (value: number) => void;
  onFetch: () => void;
  isFetching: boolean;
  /** When set, Fetch input is an estimate — backend paginates until the range is covered. */
  dateRangeActive?: boolean;

  advancedOpen: boolean;
  onToggleAdvanced: () => void;
}

export const DropsToolbar: FC<DropsToolbarProps> = ({
  search,
  onSearchChange,
  fetchLengthDraft,
  onFetchLengthDraftChange,
  onFetch,
  isFetching,
  dateRangeActive = false,
  advancedOpen,
  onToggleAdvanced,
}) => {
  return (
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
      <div className="relative flex-1">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Search locally (title, campaign, leads, sender, country, id)..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-10"
        />
      </div>

      <div className="flex flex-wrap items-center gap-2 justify-end">
        <div className="flex items-center gap-2">
          <span
            className="text-xs text-muted-foreground"
            title={
              dateRangeActive
                ? 'Rough row estimate — SMSWiser is fetched in 5k pages until your start date is covered.'
                : undefined
            }
          >
            {dateRangeActive ? 'Est. rows' : 'Fetch'}
          </span>
          <Input
            type="number"
            min={1}
            max={dateRangeActive ? 500_000 : 5000}
            value={fetchLengthDraft}
            onChange={(e) => onFetchLengthDraftChange(Number(e.target.value))}
            className="w-[110px]"
            title={
              dateRangeActive
                ? 'Estimate only. Loaded count may be higher while paginating through your date range.'
                : 'Maximum 5000 rows per fetch without a date range.'
            }
          />
        </div>

        <Button variant="outline" size="sm" onClick={onFetch} disabled={isFetching}>
          Fetch
        </Button>

        <Button
          variant={advancedOpen ? 'default' : 'outline'}
          size="sm"
          onClick={onToggleAdvanced}
          aria-label="Toggle advanced filters"
        >
          <Filter className="mr-2 h-4 w-4" />
          Advanced
        </Button>
      </div>
    </div>
  );
};

export default DropsToolbar;

